import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../components/custom-snackbar/custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarErrorService {
  constructor(private snackBar: MatSnackBar) {
  }

  open(
    message: string,
    action: string = 'Ver mais',
    duration: number = 5000,
    icon: string = 'warning',
    onActionClick?: () => void,
  ): void {
    this.snackBar.openFromComponent(CustomSnackbarComponent, {
      data: { message, action, onActionClick, icon },
      duration,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
      panelClass: ['custom-snackbar']
    });
  }
}
